export default __webpack_public_path__ + "static/media/pink-1.4000e912.png";